module.exports = __webpack_public_path__ + "static/Banner02-71a60ae67fd8ab8b71d9707222737cff.jpg";